import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import clientsReducer from './slices/clientsSlice';
import measurementsReducer from './slices/measurementsSlice';
import projectsReducer from './slices/projectsSlice';
import employeesReducer from './slices/employeesSlice';
import stagesReducer from './slices/stagesSlice';
import assignmentsReducer from './slices/assignmentsSlice';
import dressesReducer from './slices/dressesSlice';
import timeEntriesReducer from './slices/timeEntriesSlice';
import attendanceReducer from './slices/attendanceSlice';
import dashboardReducer from './slices/dashboardSlice';
import gstReducer from './slices/gstSlice';
import brandReducer from './slices/brandSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    measurements: measurementsReducer,
    projects: projectsReducer,
    employees: employeesReducer,
    stages: stagesReducer,
    assignments: assignmentsReducer,
    dresses: dressesReducer,
    timeEntries: timeEntriesReducer,
    attendances: attendanceReducer,
    dashboard: dashboardReducer,
    gst: gstReducer,
    brand: brandReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 